import { Navigate } from 'react-router-dom'

export function Year() {
  return <Navigate to="teams" />
}
